var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99975 7.29988L1.66642 4.96655C1.40642 4.70655 0.993086 4.70655 0.733086 4.96655C0.473086 5.22655 0.473086 5.63988 0.733086 5.89988L3.52642 8.69322C3.78642 8.95322 4.20642 8.95322 4.46642 8.69322L11.5331 1.63322C11.7931 1.37322 11.7931 0.959883 11.5331 0.699883C11.2731 0.439883 10.8598 0.439883 10.5998 0.699883L3.99975 7.29988Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/TickIcon.4122aa8340839cb99e58ee89994262a8.svg";
export { ForwardRef as ReactComponent };